import "@aws-amplify/ui-react/styles.css";
import {
    withAuthenticator,
    Button,
    Heading,
    Image,
    View,
    Text,
    TextField,
    SelectField,
    Card,
    Flex,
    Label,
} from "@aws-amplify/ui-react";
import { FormEvent, useEffect, useState } from "react";
import { postEvent} from "../api"
import { useNavigate } from "react-router-dom";


//data
import { useContext } from 'react';
import { GlobalContext } from '../context/global';

import {
  AH2
} from "../components/text"
import {
  APadded, NextBackButtonHolder
} from "../components/layout"
import { IEventData } from "../interfaces";
import styled from "styled-components";
import { LimitExceededException } from "@aws-sdk/client-cognito-identity-provider";
import { Loading } from "../components/loading";


interface IEventFormData {
    distanceMeters: number | null,
    estimatedDurationHours : number | null,
    estimatedDurationMinutes: number | null,
    name: IEventData['name'],
    activityType : IEventData['activityType'],
    terrain : IEventData['terrain'],
    intensity : IEventData['intensity'],
  
}

const TwoInputs = styled(View)`
    display:flex;
    width:300px;
    div:first-child {
      margin-right:5px;
    }

`


export const ViewEventNew = () => {
    const navigate = useNavigate();
    const [isPosting, setIsPosting] = useState<boolean>(false);
    const {nutritionData, setNutritionData, clearBasket, eventData, setEventData} = useContext(GlobalContext);
    const [ eventFormData, setEventFormData ] = useState<IEventFormData>({
        distanceMeters: null,
        estimatedDurationMinutes: null,
        estimatedDurationHours: null,
        name: "",
        activityType: "Running",
        terrain: "Flat",
        intensity: "Moderate",
    })

    const onEventChangeValue = (fieldName : string, newValue : string) => {
        setEventFormData({...eventFormData, [fieldName] : newValue})
    }

    const onEventChangeNumericValue = (fieldName : string, newValue : string, conversionWhenSaving: number = 1) => {
        if (newValue == "") {
        setEventFormData({...eventFormData, [fieldName] : null})
        }
        const num = parseInt(newValue);
        if (isNaN(num)) return;
        setEventFormData({...eventFormData, [fieldName] : num * conversionWhenSaving })
    }

    const goBack = () => {
        navigate("/event/menu")
      }

    const disableAll = false;
    //const disableAll = !!eventData.event;
    // ^ we don't actually need this.
    
    useEffect(() => {
        // if we see a saved event.
        // then we load it into the form fields,
        // but we disable everything
        //if (isPosting) return; // stops us setting it once we've posted.
        if (eventData.event) {
            const hours = eventData.event.estimatedDurationMinutes ? Math.floor(eventData.event.estimatedDurationMinutes / 60) : 0
            // Pull the global data into our form for them to edit.
            setEventFormData({
                distanceMeters: eventData.event.distanceMeters || null,
                estimatedDurationHours: hours || null,
                estimatedDurationMinutes: eventData.event.estimatedDurationMinutes ? eventData.event.estimatedDurationMinutes - (hours * 60) : null,
                activityType: eventData.event.activityType || "Running",
                terrain: eventData.event.terrain || "Flat",
                intensity: eventData.event.intensity || "Moderate",
                name: eventData.event.name || "",
            });
        }
    }, [eventData])


    async function createEvent(click : FormEvent) {
        click.preventDefault();
        if (!click.target || !(click.target instanceof HTMLFormElement)) {
            console.warn("CreateEvent needs to be triggered from a HTML form submit");
            return;
        }
        if (eventFormData.distanceMeters === null) return;
        if (!eventFormData.estimatedDurationHours && !eventFormData.estimatedDurationMinutes) return;

        const data = {
            name: eventFormData.name,
            distanceMeters: eventFormData.distanceMeters,
            activityType: eventFormData.activityType || "Running",
            terrain: eventFormData.terrain || "Flat",
            estimatedDurationMinutes: ((eventFormData.estimatedDurationHours || 0) * 60) + (eventFormData.estimatedDurationMinutes || 0),
            intensity: eventFormData.intensity || "Moderate",
        };
        if (data.estimatedDurationMinutes > (60 * 100)) {
            return; //basic validation max 100 hours
        }
        setIsPosting(true);
        const response = await postEvent({
            ...(data as any)
        })
        //setIsPosting(false);
        // now lets store the response data in some state.
        //props.onNutritionDataReceived(response.data);
        // console.log("Here's the response")
        // console.log(response.data);
        clearBasket();// in case they already have some stuff from a prev order.
        // save the data from the response
        setNutritionData({...response.data, hasLoaded: true});
        // save the data about the event itself
        setEventData(data);
        setTimeout(() => {
            navigate("/event/new/1/basket/calories");
        }, 500);
        
    }

    if (isPosting) {
        return <Loading message="Calculating nutrition..." />

    }

    return <APadded>
            <AH2>You describe the event<br/>we'll provide your tailored nutrition</AH2>
            <View as="form" margin="3rem 0" onSubmit={createEvent}>
            <Flex direction="Column" justifyContent="center">
            <TextField
                disabled={disableAll}
                onChange={(evt) => { onEventChangeValue("name", evt.target.value)}}
                value={eventFormData.name}
                name="name"
                placeholder="e.g. My Marathon"
                label="Event Name"
                variation="quiet"
                required
                
            />
            <SelectField
                disabled={disableAll}
                onChange={(evt) => { onEventChangeValue("activityType", evt.target.value)}}
                value={eventFormData.activityType}
                label="Activity Type"
                name="activityType"
                //descriptiveText="What type of activity does the event involve?"
            >
                <option value="Running">Running</option>
                <option value="Trail Running">Trail Running</option>
                <option value="Cycling">Cycling</option>
                <option value="Mountain Biking">Mountain Biking</option>
                <option value="Swimming (pool)">Swimming (Pool)</option>
                <option value="Swimming (open water)">Swimming (Open Water)</option>
                <option value="Hiking">Hiking</option>
            </SelectField>
            <SelectField
                disabled={disableAll}
                onChange={(evt) => { onEventChangeValue("intensity", evt.target.value)}}
                value={eventFormData.intensity}
                label="Intensity"
                name="intensity"
                //descriptiveText="What type of activity does the event involve?"
            >
                <option value="Easy">Easy</option>
                <option value="Moderate">Moderate</option>
                <option value="Fast">Fast</option>
                <option value="Intense">Intense</option>
            </SelectField>
            <TextField
                disabled={disableAll}
                onChange={(evt) => { 
                onEventChangeNumericValue("distanceMeters", evt.target.value, 1000);
                }}
                value={eventFormData.distanceMeters == null ? "" : eventFormData.distanceMeters / 1000 }
                name="distance"
                placeholder="e.g. 20"
                label="Distance (km)"
                variation="quiet"
                required
            />
            <SelectField
                disabled={disableAll}
                label="Terrain"
                name="terrain"
                value={eventFormData.terrain}
                onChange={(evt) => { onEventChangeValue("terrain", evt.target.value)}}
            >
                <option value="Flat">Flat</option>
                <option value="Hilly">Hilly</option>
                <option value="Mountainous" >Mountainous</option>
            </SelectField>
            <Label>Estimated duration (hours and mins)</Label>
            <TwoInputs>
                <TextField
                    disabled={disableAll}
                    onChange={(evt) => { 
                        onEventChangeNumericValue("estimatedDurationHours", evt.target.value);
                    }}
                    value={eventFormData.estimatedDurationHours == null ? "" : eventFormData.estimatedDurationHours }
                    name="estimatedDurationHours"
                    placeholder="e.g. 1 "
                    label="Estimated Duration (hours)"
                    labelHidden
                    variation="quiet"
                    required
                />
                <TextField
                    disabled={disableAll}
                    onChange={(evt) => { 
                        onEventChangeNumericValue("estimatedDurationMinutes", evt.target.value);
                    }}
                    value={eventFormData.estimatedDurationMinutes == null ? "" : eventFormData.estimatedDurationMinutes }
                    name="estimatedDurationMinutes"
                    placeholder="e.g. 30"
                    label="Estimated Duration (mins)"
                    labelHidden
                    variation="quiet"
                />
            </TwoInputs>
            <NextBackButtonHolder>
            <Button variation="warning" onClick={goBack}>
            ‹ Back
            </Button>
            <Button type="submit" disabled={isPosting || disableAll}>
                { isPosting ? "Just a sec" : "Next ›" }
            </Button>
            </NextBackButtonHolder>
            </Flex>
        </View >
        {/* <View margin="3rem 0">
        {notes.map((note) => (
        <Flex
            key={note.id || note.name}
            direction="row"
            justifyContent="center"
            alignItems="center"
        >
            <Text as="strong" fontWeight={700}>
            {note.name}
            </Text>
            <Text as="span">{note.description}</Text>
            <Button variation="link" onClick={() => alert("Not implemented")}>
            Delete note
            </Button>
        </Flex>
        ))} 
    </View> */}
    </APadded>
}